import { DashboardMenuOption } from 'components/dashboard-menu/constants'
import { Loading } from 'components/loading'
import { format } from 'date-fns'
import * as React from 'react'
import { Button } from 'reactstrap'
import { connect } from 'react-redux'
import * as Router from 'router'
import { DATEPICKER_DATE_FORMAT, DATETIME_FORMAT } from 'shared/constants'
import * as Modals from 'shared/modals'
import { UpcomingIssue } from 'shared_server_client/types/schedule'
import { TURN_OFF, TURN_ON } from './constants'

interface CalendarModalProps extends Modals.ModalComponentProps {
  update: (issued: any) => void
  onCustomize?: (issue: UpcomingIssue) => void
  onEditOverride?: (issue: UpcomingIssue) => void
  onDeleteOverride?: (issue: UpcomingIssue) => void
}

export class CalendarModalComponent extends Modals.GenericModalComponent<
  CalendarModalProps,
  Modals.ModalComponentState
> {
  public static key: string = 'calendarModal'
  constructor(props: CalendarModalProps) {
    super(props, CalendarModalComponent.key, 'calendarModal')
    this.state = {
      isSaving: false,
    }
  }

  protected renderChildren(data: any) {
    const sendDateTime =
      data && data.schedule ? data.schedule.start.toDate() : new Date()
    const issue: UpcomingIssue = data && data.schedule
      ? data.schedule.body.updatedIssue
      : null

    if (this.isPastIssue(data)) {
      return (
        <div className="calendar-modal-body">
          <div>
            <div className="send-time">
              <h4>Sent</h4>
              <p>{format(sendDateTime, DATETIME_FORMAT)}</p>
            </div>
            {issue && issue.status &&
            <div className="send-time">
              <h4>Status</h4>
              <p>{issue.status}</p>
            </div>
            }
            {issue && issue.num_sent != null &&
            <div className="send-time">
              <h4>Recipients</h4>
              <p>{issue.num_sent}</p>
            </div>
            }
          </div>
        </div>
      )
    }

    const displayScheduledContent = data && data.schedule && data.schedule.body
    ? data.schedule.body.updatedIssue.hasScheduledContent
    : null
    return (
      <div className="calendar-modal-body">
        {this.state.isSaving
        ? <Loading size="64" />
        : <div>
            {issue && issue.source &&
            <div className="source-info">
              <span className={`source-badge ${issue.source}`}>
                {issue.source === 'override' ? 'Override' : 'Computed'}
              </span>
            </div>
            }
            <div className="send-time">
              <h4>Schedule send time</h4>
              <p>{format(sendDateTime, DATETIME_FORMAT)}</p>
            </div>
            {issue && issue.source === 'override' && issue.schedule_override_description &&
            <div className="send-time">
              <h4>Description</h4>
              <p>{issue.schedule_override_description}</p>
            </div>
            }
            {displayScheduledContent &&
            <div className="scheduled-content-preview">
              <h4>You have Scheduled Content for this newletter</h4>
              <p onClick={this.goToScheduledContent}>View Scheduled Content</p>
            </div>
            }
            {this.renderOverrideActions(issue)}
          </div>
        }
      </div>
    )
  }

  protected doSave(data: any) {
    if (this.isPastIssue(data)) {
      return Promise.resolve({})
    }
    const issue = data && data.schedule ? data.schedule.body.updatedIssue : null
    if (issue && issue.source === 'override') {
      return Promise.resolve({})
    }
    const selectedIssue = data.schedule.body
      .updatedIssue
    this.props.update(selectedIssue)
    return Promise.resolve({})
  }

  protected getSaveText(data: any): string {
    if (this.isPastIssue(data)) {
      return 'Close'
    }
    const issue = data && data.schedule ? data.schedule.body.updatedIssue : null
    if (issue && issue.source === 'override') {
      return 'Close'
    }
    return data && data.schedule && data.schedule.body.updatedIssue.is_active ? TURN_OFF : TURN_ON
  }

  protected getTitleText(data: any): string {
    if (this.isPastIssue(data)) {
      return 'Newsletter Details'
    }
    const issue = data && data.schedule ? data.schedule.body.updatedIssue : null
    if (issue && issue.source === 'override') {
      return 'Override Details'
    }
    return this.props.title || 'Update Newsletter'
  }

  private renderOverrideActions(issue: UpcomingIssue): JSX.Element | null {
    if (!issue) return null

    if (issue.source === 'computed') {
      return (
        <div className="override-actions">
          <Button color="primary" size="sm" onClick={() => this.handleCustomize(issue)}>
            Customize
          </Button>
        </div>
      )
    }

    if (issue.source === 'override') {
      return (
        <div className="override-actions">
          <Button color="primary" size="sm" onClick={() => this.handleEditOverride(issue)}>
            Edit Override
          </Button>
          {' '}
          <Button color="danger" size="sm" onClick={() => this.handleDeleteOverride(issue)}>
            Delete Override
          </Button>
        </div>
      )
    }

    return null
  }

  private handleCustomize = (issue: UpcomingIssue) => {
    this.props.closeModal(this.key)
    if (this.props.onCustomize) {
      this.props.onCustomize(issue)
    }
  }

  private handleEditOverride = (issue: UpcomingIssue) => {
    this.props.closeModal(this.key)
    if (this.props.onEditOverride) {
      this.props.onEditOverride(issue)
    }
  }

  private handleDeleteOverride = (issue: UpcomingIssue) => {
    this.props.closeModal(this.key)
    if (this.props.onDeleteOverride) {
      this.props.onDeleteOverride(issue)
    }
  }

  private isPastIssue(data: any): boolean {
    if (data && data.schedule) {
      const sendDateTime = data.schedule.start.toDate()
      return sendDateTime < new Date()
    }
    return false
  }

  private goToScheduledContent = () => {
    const { data } = this.props.data[CalendarModalComponent.key]
    const dateString = format(data.schedule.start.toDate(), DATEPICKER_DATE_FORMAT)
    const route = DashboardMenuOption.scheduledContent
    this.props.goTo(`${route}?startDate=${dateString}&endDate=${dateString}`)
  }

}

export const CalendarModal = connect(null, {
  push: Router.push,
})(CalendarModalComponent)
